const isTrue = value => value === true || value === 1 || value === '1' || value === 'true'

// The portal API historically did not return a deployment status. Keep those
// responses compatible while treating an explicit non-ready status as offline.
export const isPortalVibeProjectDeployed = project => {
    if (project?.isDeployed !== undefined && project?.isDeployed !== null) {
        return isTrue(project.isDeployed)
    }
    const status = project?.deploymentStatus ?? project?.status
    if (status === undefined || status === null || status === '') return true
    return ['ready', 'deployed', 'running', 'online'].includes(String(status).toLowerCase())
}

export const hasPortalPageAccess = project => (
    isTrue(project?.isOwner)
    || isTrue(project?.hasPageAccess)
)

export const canRequestPortalVibeProject = project => (
    isPortalVibeProjectDeployed(project)
    && isTrue(project?.hasEntryUrl)
    && isTrue(project?.hasPageRoute)
    && !hasPortalPageAccess(project)
)

export const canCopyPageRoutePrompt = project => (
    project?.accessType === 'INTERNAL' && isTrue(project?.isOwner)
)

export const canOpenPortalVibeProject = project => (
    isPortalVibeProjectDeployed(project)
    && isTrue(project?.hasEntryUrl)
    && isTrue(project?.hasPageRoute)
    && hasPortalPageAccess(project)
)

export const getPortalVibeOpenDisabledReason = project => (
    canOpenPortalVibeProject(project) ? '' : !isPortalVibeProjectDeployed(project)
        ? '项目没有部署'
        : isTrue(project?.hasPageRoute)
        ? isTrue(project?.hasEntryUrl)
            ? '当前用户没有页面访问权限，请先申请访问'
            : '该应用暂无线上入口，暂时不可打开'
        : '该应用仅提供接口服务，暂无可打开的页面'
)
